import { useApiClient } from './apiClient';
import { useCallback, useMemo } from 'react';

export const useLocationAPIs = () => {
  const { get, post } = useApiClient();

  const fetchLocations = useCallback(async () => {
    try {
      const data = await get('api/locations');
      if (Array.isArray(data)) {
        return data;
      }
      // Handle Spring Data REST format if needed
      if (data._embedded && data._embedded.locations) {
        return data._embedded.locations;
      }
      return [];
    } catch (err) {
      console.error("Failed to fetch locations:", err);
      return [];
    }
  }, [get]);

  const addLocation = useCallback(async (locationName) => {
    try {
      // apiClient.post already does JSON.stringify, so we pass the string directly
      const response = await post('api/locations/add', locationName);
      return response;
    } catch (err) {
      console.error("Failed to add location:", err);
      return null;
    }
  }, [post]);

  const getOrCreateLocation = useCallback(async (locationName) => {
    if (!locationName || !locationName.trim()) {
      return null;
    }
    
    try {
      // Try to add the location (will return existing if already present)
      const location = await addLocation(locationName.trim());
      return location;
    } catch (err) {
      console.error("Failed to get or create location:", err);
      return null;
    }
  }, [addLocation]);

  return useMemo(() => ({
    fetchLocations,
    addLocation,
    getOrCreateLocation,
  }), [fetchLocations, addLocation, getOrCreateLocation]);
};

